import React from 'react';
interface HubSpotFormProps {
  portalId: string;
  formId: string;
  region?: string;
  className?: string;
}
const SCRIPT_ID = 'hubspot-forms-embed';

/** Embeds a HubSpot form. The embed script is added to the page once and renders every .hs-form-frame it finds. */
export function HubSpotForm({
  portalId,
  formId,
  region = 'eu1',
  className = ''
}: HubSpotFormProps) {
  const ref = React.useRef<HTMLDivElement>(null);
  const [ready, setReady] = React.useState(false);
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => {
    // Re-adding the script makes HubSpot scan the page again, so the form also renders after
    // moving between pages that remount the footer.
    document.getElementById(SCRIPT_ID)?.remove();
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://js-${region}.hsforms.net/forms/embed/${portalId}.js`;
    script.defer = true;
    script.onerror = () => setFailed(true);
    document.body.appendChild(script);
    // Hide the loading line as soon as HubSpot renders its frame.
    const node = ref.current;
    if (!node) return;
    const observer = new MutationObserver(() => {
      if (node.querySelector('iframe')) {
        setReady(true);
        observer.disconnect();
      }
    });
    observer.observe(node, {
      childList: true,
      subtree: true
    });
    if (node.querySelector('iframe')) setReady(true);
    const timeout = window.setTimeout(() => {
      if (!node.querySelector('iframe')) setFailed(true);
    }, 12000);
    return () => {
      observer.disconnect();
      window.clearTimeout(timeout);
    };
  }, [portalId, region]);
  return <div className={className} data-id="element-736" data-mp="3g33oepfvwoty">
      <div ref={ref} className="hs-form-frame" data-region={region} data-form-id={formId} data-portal-id={portalId} data-id="element-737" data-mp="3c31pgo1ja9id" />
      {!ready && <p role="status" className="text-small text-[#475569]" data-id="element-738" data-mp="cgljsq582kbo">
          {failed ? 'The signup form could not load. Please check your connection or disable content blockers, then refresh.' : 'Loading signup form…'}
        </p>}
    </div>;
}